function normalizeSpecialtyName(value) {
  return String(value ?? '').trim();
}

function specialtyCountByLower(buckets) {
  let countByLower = new Map();

  for (let bucket of buckets) {
    let key = normalizeSpecialtyName(bucket?.key);
    if (!key) {
      continue;
    }

    let lower = key.toLowerCase();
    countByLower.set(lower, (countByLower.get(lower) ?? 0) + Number(bucket.count ?? 0));
  }

  return countByLower;
}

function sortedSpecialtyNames(records) {
  let labelByLower = new Map();

  for (let record of records) {
    for (let raw of record?.marketingSpecialties ?? []) {
      let name = normalizeSpecialtyName(raw);
      if (!name) {
        continue;
      }

      let lower = name.toLowerCase();
      if (!labelByLower.has(lower)) {
        labelByLower.set(lower, name);
      }
    }
  }

  return [...labelByLower.values()].sort((a, b) => a.localeCompare(b));
}

export function buildSpecialtyFacetOptions(records = [], buckets = []) {
  let countByLower = specialtyCountByLower(buckets);

  return sortedSpecialtyNames(records).map(name => ({
    key: name,
    label: name,
    docCount: countByLower.get(name.toLowerCase()) ?? 0,
  }));
}
